(function(){
  "use strict";

  if(window.__ptbirthqB2CDialogA11yV2) return;
  window.__ptbirthqB2CDialogA11yV2 = true;

  var records = [];
  var scheduled = false;
  var focusMode = null;
  var isolation = null;
  var focusSelector = [
    "a[href]", "button:not([disabled])", "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])", "textarea:not([disabled])", "[contenteditable=true]",
    "[tabindex]:not([tabindex='-1'])"
  ].join(",");

  function isVisible(element){
    if(!element || element.hidden || element.closest("[hidden]")) return false;
    if(element.getAttribute && element.getAttribute("aria-hidden") === "true") return false;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function focusableElements(dialog){
    return Array.prototype.slice.call(dialog.querySelectorAll(focusSelector)).filter(isVisible);
  }

  function findRecord(node){
    for(var index = 0; index < records.length; index += 1){
      if(records[index].node === node) return records[index];
    }
    return null;
  }

  function remember(node, opener){
    var existing = findRecord(node);
    if(existing) return existing;
    var active = opener || document.activeElement;
    var record = {
      node:node,
      opener:active && active !== document.body && active.isConnected ? active : null,
      submitting:false
    };
    records.push(record);
    return record;
  }

  function focusElement(element){
    if(!element || !element.isConnected || !element.focus) return;
    try{ element.focus({ preventScroll:true }); }
    catch(error){ try{ element.focus(); }catch(ignore){} }
  }

  function restoreAndForget(node, fallback){
    for(var index = records.length - 1; index >= 0; index -= 1){
      var record = records[index];
      if(record.node !== node) continue;
      records.splice(index, 1);
      if(!record.submitting){
        var target = record.opener && record.opener.isConnected ? record.opener : fallback;
        /* Safari/iOS can lose a deferred return target when the dialog node is
           removed in the same task. Restore now and retry once only if needed. */
        focusElement(target);
        if(target && document.activeElement !== target) window.setTimeout(function(retryTarget){
          return function(){ focusElement(retryTarget); };
        }(target), 0);
      }
    }
  }

  function wrapperIsOpen(wrapper){
    return !!(wrapper && wrapper.isConnected && !wrapper.hidden && wrapper.getAttribute("aria-hidden") !== "true");
  }

  function staticDialogIsOpen(dialog){
    return !!(dialog && (dialog.getAttribute("aria-hidden") === "false" || dialog.classList.contains("is-open")));
  }

  function enhanceWrapper(wrapper, dialog){
    if(!wrapper || !dialog) return;
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    var open = wrapperIsOpen(wrapper) || staticDialogIsOpen(wrapper);
    var record = findRecord(wrapper);
    if(open && !record){
      remember(wrapper, wrapper.__ptbirthqReturnFocus || null);
      if(!dialog.contains(document.activeElement)){
        var focusables = focusableElements(dialog);
        focusElement(focusables[0] || dialog);
      }
    }else if(!open && record){
      restoreAndForget(wrapper);
      try{ wrapper.__ptbirthqReturnFocus = null; }catch(ignore){}
    }
  }

  function dialogEntries(){
    var entries = [];
    Array.prototype.forEach.call(document.querySelectorAll(".ptbirthq-paypalFinalModal"), function(wrapper){
      var dialog = wrapper.querySelector(".ptbirthq-paypalFinalDialog");
      if(dialog) entries.push({ wrapper:wrapper, dialog:dialog, open:true });
    });
    /* The core moves these dialogs to document.body while they are open so
       fixed positioning works inside focus mode. Keep recognizing the portal
       nodes; otherwise focus isolation would mark the visible dialog inert. */
    Array.prototype.forEach.call(document.querySelectorAll(
      "#ptbirthq-modal, #ptbirthq-gift-modal, #ptbirthq-digital-confirm, #pt-birth-quick .ptbirthq-modal"
    ), function(wrapper){
      entries.push({ wrapper:wrapper, dialog:wrapper, open:staticDialogIsOpen(wrapper) });
    });
    [
      [".ptbirthq-comboSceneModal", ".ptbirthq-comboSceneModal__dialog"],
      [".ptbirthq-autoForestInfoModal", ".ptbirthq-autoForestInfoCard"],
      [".pt-globalQuickStartForestInfo", ".pt-globalQuickStartForestInfo__card"]
    ].forEach(function(pair){
      Array.prototype.forEach.call(document.querySelectorAll(pair[0]), function(wrapper){
        var dialog = wrapper.querySelector(pair[1]);
        if(dialog) entries.push({ wrapper:wrapper, dialog:dialog, open:wrapperIsOpen(wrapper) });
      });
    });
    return entries;
  }

  function enhanceDialogs(){
    dialogEntries().forEach(function(entry){
      enhanceWrapper(entry.wrapper, entry.dialog);
      if(entry.wrapper.classList.contains("ptbirthq-paypalFinalModal")){
        var title = entry.dialog.querySelector("strong");
        if(title && !title.id) title.id = "ptbirthq-paypal-final-title";
        if(title) entry.dialog.setAttribute("aria-labelledby", title.id);
        var record = findRecord(entry.wrapper);
        if(record && entry.dialog.getAttribute("data-ptbirthq-a11y-submit-bound") !== "1"){
          entry.dialog.setAttribute("data-ptbirthq-a11y-submit-bound", "1");
          entry.dialog.addEventListener("submit", function(){ record.submitting = true; }, true);
        }
      }
    });
  }

  function focusModeOpen(root){
    return !!(root && root.isConnected && !root.hidden && root.getAttribute("data-ptbirthq-focus-mode") === "1");
  }

  function syncFocusMode(root){
    var open = focusModeOpen(root);
    if(open && !focusMode){
      var opener = document.activeElement;
      focusMode = {
        root:root,
        role:root.getAttribute("role"),
        modal:root.getAttribute("aria-modal"),
        label:root.getAttribute("aria-label")
      };
      remember(root, opener);
      root.setAttribute("role", "dialog");
      root.setAttribute("aria-modal", "true");
      root.setAttribute("aria-label", "Zertifikat bearbeiten");
      if(!root.contains(document.activeElement)) focusElement(root.querySelector("#ptbirthq-focus-close"));
    }else if(!open && focusMode){
      var old = focusMode;
      focusMode = null;
      if(old.root.isConnected){
        if(old.role === null) old.root.removeAttribute("role"); else old.root.setAttribute("role", old.role);
        if(old.modal === null) old.root.removeAttribute("aria-modal"); else old.root.setAttribute("aria-modal", old.modal);
        if(old.label === null) old.root.removeAttribute("aria-label"); else old.root.setAttribute("aria-label", old.label);
      }
      restoreAndForget(old.root, old.root.querySelector("#ptbirthq-focus-resume"));
    }
  }

  function restoreIsolation(){
    if(!isolation) return;
    isolation.nodes.forEach(function(item){
      if(!item.node.isConnected) return;
      if(item.inert === null) item.node.removeAttribute("inert"); else item.node.setAttribute("inert", item.inert);
      if(item.aria === null) item.node.removeAttribute("aria-hidden"); else item.node.setAttribute("aria-hidden", item.aria);
    });
    isolation = null;
  }

  function isolateAround(target){
    if(isolation && isolation.target === target) return;
    restoreIsolation();
    if(!target || !target.isConnected) return;
    var nodes = [];
    var branch = target;
    while(branch && branch !== document.body){
      var parent = branch.parentElement;
      if(!parent) break;
      Array.prototype.forEach.call(parent.children, function(sibling){
        if(sibling === branch || /^(SCRIPT|STYLE|LINK|META|NOSCRIPT)$/.test(sibling.tagName)) return;
        nodes.push({
          node:sibling,
          inert:sibling.hasAttribute("inert") ? sibling.getAttribute("inert") : null,
          aria:sibling.hasAttribute("aria-hidden") ? sibling.getAttribute("aria-hidden") : null
        });
        sibling.setAttribute("inert", "");
        sibling.setAttribute("aria-hidden", "true");
      });
      branch = parent;
    }
    isolation = { target:target, nodes:nodes };
  }

  function cleanupDetachedDialogs(){
    for(var index = records.length - 1; index >= 0; index -= 1){
      if(!records[index].node.isConnected) restoreAndForget(records[index].node);
    }
  }

  function topEntry(){
    var entries = dialogEntries();
    for(var index = entries.length - 1; index >= 0; index -= 1){
      if(entries[index].open) return entries[index];
    }
    var root = document.getElementById("pt-birth-quick");
    if(focusModeOpen(root)) return { wrapper:root, dialog:root, open:true, focusMode:true };
    return null;
  }

  function run(){
    scheduled = false;
    var root = document.getElementById("pt-birth-quick");
    enhanceDialogs();
    syncFocusMode(root);
    cleanupDetachedDialogs();
    var entry = topEntry();
    isolateAround(entry && entry.wrapper);
    if(!entry) restoreIsolation();
  }

  function schedule(){
    if(scheduled) return;
    scheduled = true;
    if(window.requestAnimationFrame) window.requestAnimationFrame(run);
    else window.setTimeout(run, 0);
  }

  function closeSelector(dialog){
    return dialog.querySelector(
      ".ptbirthq-paypalFinalClose, .ptbirthq-paypalFinalCancel, #ptbirthq-modal-close, " +
      "#ptbirthq-gift-modal-close, #ptbirthq-gift-modal-cancel, #ptbirthq-digital-confirm-close, " +
      ".ptbirthq-comboSceneModal__close, [data-ptbirthq-auto-forest-info-close], " +
      "[data-ptg-forest-info-close], #ptbirthq-focus-close"
    );
  }

  document.addEventListener("keydown", function(event){
    var entry = topEntry();
    if(!entry) return;
    var dialog = entry.dialog;
    if(event.key === "Escape"){
      var close = entry.focusMode ? dialog.querySelector("#ptbirthq-focus-close") : closeSelector(dialog);
      if(close){
        event.preventDefault();
        event.stopPropagation();
        if(event.stopImmediatePropagation) event.stopImmediatePropagation();
        close.click();
      }
      return;
    }
    if(event.key !== "Tab") return;
    var focusables = focusableElements(dialog);
    if(!focusables.length){
      event.preventDefault();
      focusElement(dialog);
      return;
    }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if(!dialog.contains(document.activeElement)){
      event.preventDefault();
      focusElement(first);
    }else if(event.shiftKey && document.activeElement === first){
      event.preventDefault();
      focusElement(last);
    }else if(!event.shiftKey && document.activeElement === last){
      event.preventDefault();
      focusElement(first);
    }
  }, true);

  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:["aria-hidden", "class", "hidden", "data-ptbirthq-focus-mode"]
  });

  window.addEventListener("pageshow", schedule);
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule, { once:true });
  else schedule();
}());
